<script>
export default {
    data(){
        return {}
    },
    methods: {
        startCamera(camera){
            return new Promise( async(reslove,reject) => {
                this.cam.attachElement(camera);
                var param = {};
                param.show_type = 1;		//0 1 2
                var result = await this.cam.startCamera(param);
                console.info(JSON.stringify(result));
                if(result.result==0){
                    console.info("开启摄像头成功");
                    reslove()
                }else{
                    console.error("开启发生错误:"+result.message);
                    reject()
                }
            })
            
        },
        // 活体检测
        liveCapture(){
            return new Promise( async(reslove,reject) => {
                var param ={};
                param.action = "live_capture";
                param.face_image = true;
                param.infrared_face_image = true;
                var result = await this.cam.capture(param);
                // console.info(JSON.stringify(result));
                if(result.result==0){
                    reslove(result)
                }else{
                    console.error("拍照发生错误:"+result.message);
                    reject()
                }
            })
            
        },
        // 取消拍照
        cancelPhotos(){
            return new Promise( async(reslove,reject) => {
                var result = await this.cam.cancel();
                console.info(JSON.stringify(result));
                if(result.result==0){
                    console.info("取消成功");
                    reslove()
                }else{
                    console.error("取消发生错误:"+result.message);
                    reject()
                }
            })
        },
        // 关闭摄像头
        async stopCamera(){
            return new Promise( async(reslove,reject) => {
                var result = await this.cam.stopCamera();
                    console.info(JSON.stringify(result));
                if(result.result==0){
                    console.info("关闭摄像头成功");
                    reslove()
                }else{
                    console.error("关闭发生错误:"+result.message);
                    reject()
                }
            })
        }
    }
}
</script>
